import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import TenantForm from "@components/forms/TenantForm";

type TenantAddEditProps = {
  copyData?: boolean
}

const TenantAddEdit = (props: TenantAddEditProps) => {
  const { copyData = false } = props
  const params = useParams()
  const { id: copyTenantId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Agregar Suscripcion"
      backUrl="/admin/suscriptions"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "TenantAddEdit",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <TenantForm
        id={copyTenantId}
        copyData={copyData}
        saveRedirectUrl="/admin/suscriptions"
        formId="TenantAddEdit" >
      </TenantForm>

    </PageContainer>
  );
}

export default TenantAddEdit;
